import { history } from 'ice';
import React, { useState } from 'react';

import client from '@/lib/feathers';

import styles from './MobileHomeIcon.module.scss';

const MobileHomeIcon = (props) => {
  const [srcPath, setSrcPath] = useState(`icon/${props.name}.svg`);
  const [disableSrcPath, setDisableSrcPath] = useState(
    `icon/${props.name}.svg`
  );
  const message = client.service('message');

  const getQuery = (userId, messageClass) => {
    let query = { userId };
    if (messageClass === 'publicAppointmentHour') {
      query = {
        ...query,
        $or: [
          { class: 'publicAppointmentHour' },
          { class: 'publicAppointmentCount' },
        ],
      };
      return query;
    }

    return {
      ...query,
      class: messageClass,
      readed: false,
    };
  };

  const handleClick = () => {
    const path = props.paths[props.paths.length - 1].path;
    // console.log('==click',props.name,path,history)
    console.log('==click', props);

    if (props && props?.msg && props?.msg.id) {
      const query = getQuery(props.msg.id, props.msg.class);

      message.patch(null, { readed: true }, { query }).catch((err) => {
        console.log('==messags patch icon readed=true fail:', err);
      });
    }

    history.push(path);
  };
  // console.log('==MobileHomeIcon props:', props);

  return (
    <button
      type="button"
      className={styles.MobileHomeIcon}
      onClick={handleClick}
      key={props.key}
      id={props.key}
    >
      <img
        className={styles.ItemIcon}
        src={props.disable ? disableSrcPath : srcPath}
        alt={props.name}
        onError={() =>
          props.disable
            ? setDisableSrcPath('icon/ic_default.svg')
            : setSrcPath('icon/ic_default.svg')
        }
      />

      <div className={styles.ItemText}>{props.name}</div>
      {props?.msg?.count == null ? (
        ''
      ) : (
        <span className={styles.msgCount}>{props.msg.count}</span>
      )}
    </button>
  );
};

export default MobileHomeIcon;
